import { defaultMappingFormData } from '../../mappings/schema/defaultValues';
import type { AlgorithmJoinsAndMappingsGraphNodeOfType } from './types';

export const getDefaultAlgorithmSourceNode =
  (): AlgorithmJoinsAndMappingsGraphNodeOfType<'algorithmSource'> => ({
    id: window.crypto.randomUUID(),
    type: 'algorithmSource',
    position: { x: 0, y: 0 },
    data: {
      algorithmSourceId: null!,
      joinTypeCode: null,
      items: [],
    },
  });

export const getDefaultAlgorithmMappingNode =
  (): AlgorithmJoinsAndMappingsGraphNodeOfType<'algorithmMapping'> => ({
    id: window.crypto.randomUUID(),
    type: 'algorithmMapping',
    position: { x: 0, y: 0 },
    data: {
      algorithmMapping: defaultMappingFormData,
    },
  });

export const getDefaultConstantNode =
  (): AlgorithmJoinsAndMappingsGraphNodeOfType<'constant'> => ({
    id: window.crypto.randomUUID(),
    type: 'constant',
    position: { x: 0, y: 0 },
    data: { constantValue: '' },
  });
